<template>
    <div class="subpage-title-wrapper" data-aos="fade-up">
        <h2>{{ title }}</h2>
        <div class="content-wrap">
            <p v-html="subText"></p>
            <div class="button-wrap" v-if="$slots.default">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        subText: {
            type: String,
        },
    },
};
</script>
<style lang="scss" scoped>
.subpage-title-wrapper {
    width: 100%;
    padding: 100px 0 72px;
    max-width: 1540px;
    margin: 0 auto;

    h2 {
        font-family: "Pretendard", sans-serif;
        font-size: 50px;
        color: var(--black1);
        letter-spacing: -0.025em;
        font-weight: 700;
        margin: 0;
        padding: 0;
        margin-bottom: 28px;

        @media screen and (max-width: 1280px) {
            font-size: 38px;
        }

        @media screen and (max-width: 768px) {
            font-size: 30px;
        }
    }

    .content-wrap {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        p {
            font-family: "Pretendard", sans-serif;
            font-size: 18px;
            color: var(--black2);
            letter-spacing: -0.025em;
            font-weight: 400;
            line-height: 1.6;
            flex: 1;
            margin: 0;
            margin-right: 20px;
            word-break: keep-all;
        }

        .button-wrap {
            margin-left: auto;
            flex: 0 0 auto;
            display: flex;
            gap: 20px;
        }

        @media screen and (max-width: 1280px) {
            flex-direction: column;
            align-items: flex-start;

            p {
                width: 100%;
                font-size: 16px;
                margin: 0;
            }

            .button-wrap {
                margin-left: 0;
                margin-top: 30px;
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    .subpage-title-wrapper {
        width: 100%;
        padding: 100px 0 72px;
        max-width: 90%;
    }
}

@media screen and (max-width: 768px) {
    .subpage-title-wrapper {
        width: 100%;
        padding: 50px 0;
        max-width: 90%;
    }
}
</style>
